var map = {
	"./AskFor.js": 4692,
	"./ChoiceType.js": 453,
	"./ComponentsList.js": 598,
	"./Delete.js": 830,
	"./DetailPage.js": 179,
	"./DownLoad.js": 2437,
	"./IsOpen.js": 4707,
	"./Mess.js": 52,
	"./Move.js": 2438,
	"./MyUpload.js": 4708,
	"./NewFolder.js": 2439,
	"./NewFolderModel.js": 588,
	"./Partake.js": 1103,
	"./Pattern.js": 852,
	"./PersonalLibrary.js": 1576,
	"./Position.js": 293,
	"./RelationshipMap.js": 4712,
	"./Removal.js": 1574,
	"./Rename.js": 1104,
	"./Select.js": 1105,
	"./SetLabel.js": 1481,
	"./Share.js": 1476,
	"./StorageSpace.js": 1182,
	"./UpLoad.js": 1575,
	"./UploadStatus.js": 600,
	"./User.js": 1573,
	"./apply.js": 599,
	"./config-resourceIcon.js": 868,
	"./config/BtnConfig.js": 4713,
	"./detaiPageItem/detail-config.js": 831,
	"./detaiPageItem/detailAudio.js": 1477,
	"./detaiPageItem/detailOtherFile.js": 1478,
	"./detaiPageItem/detailPicture.js": 1479,
	"./detaiPageItem/detailVideo.js": 1054,
	"./detailPageRight/RelatedResources.js": 1571,
	"./detailPageRight/RelationshipMap.js": 851,
	"./detailPageRight/Version.js": 1572,
	"./fileLibrary/FileLibrary.js": 682,
	"./fileLibrary/audio/Audio.js": 1482,
	"./fileLibrary/img/svg.js": 1056,
	"./fileLibrary/option/OptionRange.js": 446,
	"./fileLibrary/option/component/company.js": 761,
	"./fileLibrary/option/component/duration.js": 762,
	"./fileLibrary/option/component/fileSize.js": 763,
	"./fileLibrary/option/component/fileTime.js": 764,
	"./fileLibrary/option/component/format.js": 765,
	"./fileLibrary/option/component/jurisdiction.js": 766,
	"./fileLibrary/option/component/media.js": 767,
	"./fileLibrary/option/component/path.js": 768,
	"./fileLibrary/option/component/status.js": 769,
	"./fileLibrary/option/component/widthAndHeight.js": 770,
	"./fileLibrary/option/option-config.js": 1483,
	"./fileLibrary/other_file/Other_file.js": 1484,
	"./fileLibrary/picture/Picture.js": 1485,
	"./fileLibrary/video/Video.js": 1486,
	"./pageTable/PageTable.js": 159,
	"./resourcePool/ResourcePool.js": 706,
	"./resourcePool/ResourcePoolDemo.js": 4719,
	"./resourcePool/Table.js": 850,
	"./resourcePool/audio/Audio.js": 1569,
	"./resourcePool/categoryInfo/CategoryInfo.js": 4720,
	"./resourcePool/file/File.js": 1568,
	"./resourcePool/picture/Picture.js": 849,
	"./resourcePool/uploadSetting.js": 427,
	"./resourcePool/video/Video.js": 1570,
	"./story.js": 4722,
	"./svg/Svg.js": 373
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 673;